export default "__VITE_ASSET__Dmk$vWsj__"